import {Component, EventEmitter, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';
import {EstatusProcesoEnum, HeaderEnum, ProcesoImportarEnum, RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {DialogoOpcion} from '@mensaje/Modelo/Dialogo.model';
import {AlertaEnum, DialogoEnum, TipoOpcionEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {ImpotacionAnalisis, ImportarProceso} from '@modelo/SIConvertAnalisis.model';

import {Colaborador} from '@modelo/catalogo/Colaborador.model';
@Component(
    {
        selector: 'colaborador_layout',
        templateUrl: './colaborador_layout.template.html',
        styleUrls: ['./colaborador_layout.scss']
    })

export class ColaboradorLayoutComponent {
    datoGuardado: boolean = false;
    @Output() cerrarImportacion: EventEmitter<any> = new EventEmitter();

    errorActivo: boolean = false;

    archivo: any = {Archivo: "", MimeType: "", Nombre: ""};

    importacion: ImpotacionAnalisis = new ImpotacionAnalisis();
    estatusProceso: ProcesoImportarEnum = ProcesoImportarEnum.Inico;
    pasos: Array<ImportarProceso> = [];

    ProcesoSIConvertEnum = ProcesoImportarEnum;
    EstatusProcesoEnum = EstatusProcesoEnum;

    Colaboradores!: Colaborador[];

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.pasos.push(new ImportarProceso({Titulo: this.translate.instant("Layout.Importacion.Paso1"), Estatus: EstatusProcesoEnum.Pendiente}));
        this.pasos.push(new ImportarProceso({Titulo: this.translate.instant("Layout.Importacion.Paso2"), Estatus: EstatusProcesoEnum.Pendiente}));
        this.pasos.push(new ImportarProceso({Titulo: this.translate.instant("Layout.Importacion.Paso3"), Estatus: EstatusProcesoEnum.Pendiente}));
    }

    ngOnInit() {
        this.archivo = {Archivo: "", MimeType: "", Nombre: ""};
        this.estatusProceso = ProcesoImportarEnum.Inico;
        this.IniciarDatos();

        this.errorActivo = false;
    }

    IniciarDatos() {
        this.importacion = new ImpotacionAnalisis();
        this.pasos[0].Estatus = EstatusProcesoEnum.Pendiente;
        this.pasos[1].Estatus = EstatusProcesoEnum.Pendiente;
        this.pasos[2].Estatus = EstatusProcesoEnum.Pendiente;

        this.pasos[1].Titulo = this.translate.instant("Layout.Importacion.Paso2");
        this.pasos[2].Titulo = this.translate.instant("Layout.Importacion.Paso3");
    }

    ValidarArchivo() {
        this.errorActivo = true;

        if (!this.archivo.Archivo) {
            this.mensajeService.Alerta(AlertaEnum.Warning, 'Selecciones un archivo valido');
            return;
        }

        this.IniciarDatos();
        this.pasos[0].Estatus = EstatusProcesoEnum.Procesando;

        this.estatusProceso = ProcesoImportarEnum.Procesando;

        this.appService.Post("configuracionrh/colaborador/layout/validar/file", this.archivo, [HeaderEnum.NoShowLoading]).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {

                var analisis = res.data;

                if (!analisis.Finalizado) {
                    this.estatusProceso = ProcesoImportarEnum.Error;
                    this.pasos[0].Estatus = EstatusProcesoEnum.Error;
                }
                else {
                    this.estatusProceso = ProcesoImportarEnum.Validado;
                    this.pasos[0].Estatus = EstatusProcesoEnum.Success;

                    this.importacion.Registros = analisis.Registros;
                    this.Colaboradores = [];
                    this.ValidarDatosRow();
                }

                this.importacion.Errores = analisis.Errores;
            }
            else {
                this.estatusProceso = ProcesoImportarEnum.Error;
                this.pasos[0].Estatus = EstatusProcesoEnum.Error;
            }
        }).catch(err => {
            this.estatusProceso = ProcesoImportarEnum.Inico;
            this.pasos[0].Estatus = EstatusProcesoEnum.Pendiente;
        })
    }

    ValidarDatosRow() {
        this.pasos[1].Estatus = EstatusProcesoEnum.Procesando;
        this.pasos[1].Titulo = this.translate.instant("Layout.Importacion.Paso2") + " " + this.importacion.Renglon + " " + this.translate.instant("Layout.Importacion.De") + " " + this.importacion.Registros + " (" + this.sistemaService.Calcularporcentage(this.importacion.Renglon, this.importacion.Registros) + "%)";

        this.appService.Post("configuracionrh/colaborador/layout/validar/renglon/" + this.importacion.Renglon, this.archivo, [HeaderEnum.NoShowLoading]).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                let respuesta = res.data;

                this.importacion.Renglon += 1;

                this.importacion.Correctos += respuesta.Correctos;
                this.importacion.Incorrectos += respuesta.Incorrectos;
                this.importacion.Omitidos += respuesta.Omitidos;

                this.importacion.Errores = this.importacion.Errores.concat(respuesta.Errores);
                this.importacion.Advertencias = this.importacion.Advertencias.concat(respuesta.Advertencias);

                if (respuesta.Entidad && !respuesta.Omitidos) {
                    let colaborador = new Colaborador(respuesta.Entidad);
                    this.Colaboradores.push(colaborador)
                }

                if (this.importacion.Renglon >= this.importacion.Registros) {
                    if (this.importacion.Errores.length > 0) {
                        this.estatusProceso = ProcesoImportarEnum.Error;
                        this.pasos[1].Estatus = EstatusProcesoEnum.Error;
                    }
                    else {
                        this.estatusProceso = ProcesoImportarEnum.EnEspera;
                        this.pasos[1].Estatus = EstatusProcesoEnum.Success;

                        this.importacion.Errores = this.importacion.Advertencias;
                    }

                    this.pasos[1].Titulo = this.translate.instant("Layout.Importacion.Paso2") + ". " + this.translate.instant("Layout.Importacion.Completado");
                }
                else {
                    this.ValidarDatosRow();
                }
            }
            else {
                this.estatusProceso = ProcesoImportarEnum.Error;
                this.pasos[1].Estatus = EstatusProcesoEnum.Error;
            }
        }).catch(err => {
            this.estatusProceso = ProcesoImportarEnum.Error;
            this.pasos[1].Estatus = EstatusProcesoEnum.Error;
        })
    }

    ImportarDatos(indexInicio: number) {
        this.estatusProceso = ProcesoImportarEnum.Expotando;
        this.pasos[2].Estatus = EstatusProcesoEnum.Procesando;
        this.pasos[2].Titulo = this.translate.instant("Layout.Importacion.Paso3") + " " + this.importacion.Importados + " " + this.translate.instant("Layout.Importacion.De") + " " + (this.importacion.Registros - this.importacion.Omitidos) + " (" + this.sistemaService.Calcularporcentage(this.importacion.Importados, this.importacion.Registros - this.importacion.Omitidos) + "%)";

        this.appService.Post("configuracionrh/colaborador", this.Colaboradores[indexInicio], [HeaderEnum.NoShowLoading]).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.importacion.Importados += 1;
                this.Terminar(indexInicio + 1);

            }
            else {
                this.estatusProceso = ProcesoImportarEnum.Error;
                this.pasos[2].Estatus = EstatusProcesoEnum.Error;
            }
        }).catch(err => {
            if (err.status == RespuestaEstatusEnum.Parcial) {
                this.importacion.Omitidos += 1;
                this.Terminar(indexInicio + 1);
            } else {
                this.estatusProceso = ProcesoImportarEnum.Error;
                this.pasos[2].Estatus = EstatusProcesoEnum.Error;
            }
        })
    }

    Terminar(indexInicio: number) {
        if (indexInicio >= this.importacion.Registros) {
            this.estatusProceso = ProcesoImportarEnum.Finalizado;
            this.pasos[2].Estatus = EstatusProcesoEnum.Success;

            this.pasos[2].Titulo = this.translate.instant("Layout.Importacion.Paso3") + ". " + this.translate.instant("Layout.Importacion.Completado");
            this.datoGuardado = true;
        }
        else {
            this.ImportarDatos(indexInicio);
        }
    }

    Salir() {
        let opciones = [];

        opciones.push(new DialogoOpcion({Titulo: this.translate.instant("Salir"), Valor: 1}));
        opciones.push(new DialogoOpcion({Titulo: this.translate.instant("Cancelar"), Valor: 2, Tipo: TipoOpcionEnum.negativo}));

        this.mensajeService.Dialogo(DialogoEnum.normal, "", this.translate.instant("MensajeSalir"), opciones).then((respuesta: number) => {
            if (respuesta == 1) {
                this.CerrarModal();
            }
        });
    }

    CerrarModal() {
        this.cerrarImportacion.emit(this.datoGuardado);
    }

}
